import {
  Component,
  Input,
  OnInit,
  forwardRef,
  Output,
  EventEmitter
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValuePair } from 'app/shared/interfaces/ValuePair';

@Component({
  selector: 'ls-multi-checkbox',
  templateUrl: 'ls-multi-checkbox.component.html',
  styleUrls: ['ls-multi-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LsMultiCheckboxComponent),
      multi: true
    }
  ]
})
export class LsMultiCheckboxComponent implements OnInit, ControlValueAccessor {
  @Input()
  public disabled: boolean;
  @Input()
  public visible = true;
  @Input()
  public options: Array<ValuePair>;
  @Output()
  public selectionChanged: EventEmitter<{
    totalOptions: Number;
    totalSelected: Number;
  }> = new EventEmitter<{ totalOptions: Number; totalSelected: Number }>();

  public selections: Array<string> = [];

  public values: Array<ValuePair> = [];

  public ngOnInit(): void {
    if (Array.isArray(this.options)) {
      this.values = this.options;
      if (this.selections.length === 0) {
        this.selections = this.values.map((option: ValuePair) => option.value);
      }
      this.selectionChanged.emit({
        totalOptions: this.values.length,
        totalSelected: this.selections.length
      });
    }
  }

  public handleOptionClick(key: string): void {
    if (this.selections.indexOf(key) > -1) {
      this.selections.splice(this.selections.indexOf(key), 1);
    } else {
      this.selections.push(key);
    }
    const totalSelected = this.selections.length;

    this.propagateChange(this.cleanupArray());
    this.selectionChanged.emit({
      totalOptions: this.values.length,
      totalSelected: totalSelected
    });
  }

  public cleanupArray(): Array<string> {
    let completeSelection = true;
    if (this.selections.length === this.values.length) {
      this.values.forEach((value: ValuePair) => {
        completeSelection =
          completeSelection || this.selections.includes(value.value);
      });
      if (completeSelection) {
        return [];
      }
    }
    return [...this.selections];
  }

  public isSoleSelection(key: string): boolean {
    return this.selections.length === 1 && this.selections.indexOf(key) === 0;
  }

  public isSelected(key: string): boolean {
    return this.selections.indexOf(key) > -1;
  }

  public writeValue(value: Array<string>): void {
    if (Array.isArray(value)) {
      this.selections = value;
      if (this.selections.length === 0 && this.values.length) {
        this.selections = this.values.map((option: ValuePair) => option.value);
      }
      this.selectionChanged.emit({
        totalOptions: this.values.length,
        totalSelected: this.selections.length
      });
    } else {
      this.selections = [];
      if (this.values.length) {
        this.selections = this.values.map((option: ValuePair) => option.value);
      }
      this.selectionChanged.emit({
        totalOptions: this.values.length,
        totalSelected: this.selections.length
      });
    }
  }

  public registerOnChange(fn: Function): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(): void {
    return;
  }

  public propagateChange: any = () => {
    return;
  };
}
